import { BrickWall } from "lucide-react";
import Link from "next/link";
import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

interface LogoProps extends Omit<ComponentProps<typeof Link>, "href"> {
	href?: string;
	showText?: boolean;
	text?: string;
	textClassName?: string;
	iconClassName?: string;
	strokeWidth?: number;
}

export function Logo({
	className,
	href = "/",
	showText = true,
	text = "BRIK",
	textClassName,
	iconClassName,
	strokeWidth,
	...props
}: LogoProps) {
	return (
		<Link
			href={href}
			className={cn("flex items-center gap-2", className)}
			{...props}
		>
			<BrickWall
				className={cn("h-6 w-6", iconClassName)}
				strokeWidth={strokeWidth}
			/>
			{showText && (
				<span
					className={cn("text-xl font-bold tracking-tighter", textClassName)}
				>
					{text}
				</span>
			)}
		</Link>
	);
}
